export const EBILL_ATTACHMENTS_ADD = "EBILL_ATTACHMENTS_ADD";
export const EBILL_ATTACHMENTS_ADD_SUCCESS = "EBILL_ATTACHMENTS_ADD_SUCCESS";
export const EBILL_ATTACHMENTS_ADD_ERROR = "EBILL_ATTACHMENTS_ADD_ERROR";
export const EBILL_ATTACHMENT_DELETE = "EBILL_ATTACHMENT_DELETE";
export const EBILL_ATTACHMENT_DELETE_SUCCESS = "EBILL_ATTACHMENT_DELETE_SUCCESS";
export const EBILL_ATTACHMENT_DELETE_ERROR = "EBILL_ATTACHMENT_DELETE_ERROR";